module.exports = __webpack_public_path__ + "img/YellowCard.1ac43457.png";